import * as yup from 'yup';
import { HeroSlide } from '@web/components';
import {
  linkSchema,
  createInlineRichTextFromCMSSchema,
  inlineRichTextFromCMSSchema,
  headlineVariantsSchema,
} from '../schemas';
import { schema as flexibleImage } from './flexible_picture';
import { schema as emailCaptureSchema } from './email_capture';
import { schema as ctaGroupSchema } from './cta_group';
import { schema as muxVideoSchema } from './mux_video';
import { schema as typewriterSchema } from './typewriter';
import { schema as heroStatsSchema } from './hero_stats';
import { schema as heroBadgesSchema } from './hero_badges';

export const component = HeroSlide;

export const schema = yup
  .object({
    headline: yup.mixed().when('level', {
      is: val => !!val,
      then: yup.lazy((_, ctx) => {
        return createInlineRichTextFromCMSSchema(ctx.parent.level);
      }),
      otherwise: inlineRichTextFromCMSSchema,
    }),
    headlineVariants: yup.mixed().when('level', {
      is: val => !!val,
      then: yup.lazy((_, ctx) => {
        return headlineVariantsSchema(ctx.parent.level);
      }),
      otherwise: headlineVariantsSchema(),
    }),
    subheadline: inlineRichTextFromCMSSchema,
    cta: yup.lazy(item => {
      switch (item?.component) {
        case 'email_capture':
          return emailCaptureSchema;
        case 'cta_group':
          return ctaGroupSchema;
        default:
          return linkSchema;
      }
    }),
    backgroundAsset: yup.lazy(item => {
      switch (item?.component) {
        case 'flexible_picture':
          return flexibleImage;
        case 'mux_video':
          return muxVideoSchema;
        default:
          return yup.mixed();
      }
    }),
    pill: yup.object(),
    eyebrow: yup.lazy(item => {
      switch (item?.component) {
        case 'typewriter':
          return typewriterSchema;
        default:
          return yup.mixed();
      }
    }),
    accessoryComponent: yup.lazy(item => {
      switch (item?.component) {
        case 'hero_stats':
          return heroStatsSchema;
        case 'hero_badges':
          return heroBadgesSchema;
        default:
          return yup.mixed();
      }
    }),
    backgroundColor: yup.string(),
    fontColor: yup.string(),
    typography: yup.string(),
  })
  .transform(value => ({
    headline: value.headline,
    headlineVariants: value.headline_variants,
    subheadline: value.subheadline,
    cta: value.cta?.[0] || undefined,
    backgroundAsset: value.background_asset?.[0],
    pill: value.pill?.[0],
    eyebrow: value.eyebrow?.[0],
    accessoryComponent: value.accessory_component?.[0],
    backgroundColor: value.background_color || undefined,
    fontColor: value.font_color || undefined,
    typography: value.typography || undefined,
  }));
